import type { ReactNode } from 'react'
import React from 'react'

import * as S from './styled'

export type Props = {
  children: ReactNode
}

export const NotificationIndicator = ({ children }: Props) => {
  return <S.Container>{children}</S.Container>
}
